import TaskList from "./components/List"
import TaskForm from "./components/Form"
import TaskView from "./components/View"

let module = "drivingtests"

export default [
  { path: "drivingtests", component: TaskList, meta: { module: module, permissions: ["drivingtest-access"] } },
  {
    path: "drivingtests/create",
    component: TaskForm,
    props: true,
    meta: { module: module, permissions: ["drivingtest-create"] }
  },
  {
    path: "drivingtests/edit/:id",
    component: TaskForm,
    props: true,
    meta: { module: module, permissions: ["drivingtest-edit"] }
  },
  {
    path: "drivingtests/view/:id",
    component: TaskView,
    props: true,
    meta: { module: module, permissions: ["drivingtest-access"] }
  }
]
